import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '../../../lib/supabase';

const LineCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleAuthCallback = async () => {
      const code = searchParams.get('code');
      const state = searchParams.get('state');
      const error = searchParams.get('error');
      const errorDescription = searchParams.get('error_description');

      // エラーがある場合
      if (error) {
        console.error('LINE Auth Error:', error, errorDescription);
        navigate(`/login?error=${error}&message=${encodeURIComponent(errorDescription || 'LINE認証に失敗しました')}`);
        return;
      }

      // codeがない場合
      if (!code) {
        navigate('/login?error=no_code&message=認証コードが取得できませんでした');
        return;
      }

      // stateを検証（セッションストレージに保存されている場合）
      const storedState = sessionStorage.getItem('line_oauth_state');
      if (storedState && state !== storedState) {
        console.error('State mismatch - possible CSRF attack');
        navigate('/login?error=invalid_state&message=セキュリティエラーが発生しました');
        return;
      }
      sessionStorage.removeItem('line_oauth_state');

      try {
        // Supabase Functions invokeを使ってcodeを検証し、セッションを取得
        const { data, error } = await supabase.functions.invoke('line-auth', {
          body: { 
            code: code,
            state: state 
          }
        });

        if (error) {
          throw error;
        }
        
        // 返されたトークンでセッションを設定
        if (data.access_token && data.refresh_token) {
          const { error: sessionError } = await supabase.auth.setSession({
            access_token: data.access_token,
            refresh_token: data.refresh_token,
          });

          if (sessionError) {
            throw sessionError;
          }

          // ログイン成功後、ダッシュボードにリダイレクト
          navigate('/dashboard');
        } else {
          throw new Error('No session tokens received');
        }

      } catch (error) {
        console.error('LINE Auth Callback Error:', error);
        navigate(`/login?error=auth_failed&message=${encodeURIComponent(error.message || 'LINE認証に失敗しました')}`);
      }
    };

    handleAuthCallback();
  }, [navigate, searchParams]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      fontFamily: 'sans-serif'
    }}>
      <div style={{
        padding: '2rem',
        textAlign: 'center'
      }}>
        <h2>LINE認証中...</h2>
        <p>しばらくお待ちください</p>
        <div style={{
          marginTop: '1rem',
          display: 'inline-block',
          width: '40px',
          height: '40px',
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #00B900',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
      </div>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default LineCallback;